import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BaseStoreIcon = ({ className }: IProps) => (
    <svg
        className={className}
        fill="black"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M20.6 10.5c-.9 0-1.7-.4-2.2-1-.6.6-1.4 1-2.2 1-.8 0-1.7-.4-2.2-1-.6.6-1.4 1-2.2 1-.8 0-1.7-.4-2.2-1-.6.6-1.4 1-2.2 1-.8 0-1.7-.4-2.2-1-.6.6-1.4 1-2.2 1-1.7 0-3-1.3-3-3v-.2l1.4-6.2C1.5.5 1.7 0 2.5 0h18.3c.7 0 1.3.5 1.5 1.2l1.3 6.1v.2c0 1.7-1.3 3-3 3Zm-2.2-3.7c.4 0 .8.3.8.8-.1.7.6 1.4 1.4 1.4.8 0 1.5-.6 1.5-1.4l-1.4-6.1H2.5L1.1 7.6c0 .8.7 1.4 1.5 1.4s1.5-.7 1.5-1.5c0-.4.3-.8.8-.8s.7.4.7.8c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5c0-.4.3-.8.8-.8s.8.3.8.8c-.1.8.6 1.5 1.4 1.5.8 0 1.5-.7 1.5-1.5 0-.4.3-.8.8-.8s.7.4.7.8c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5c0-.4.3-.7.8-.7ZM3.4 24c-1.2 0-2.2-1-2.2-2.2v-9c0-.4.3-.8.8-.8s.6.3.6.8v9c0 .4.3.8.8.8h8.2v-6.2c0-2.1 1.7-3.8 3.8-3.8 2.1 0 3.8 1.7 3.8 3.8v6.2h.7c.4 0 .8-.3.8-.8v-9c0-.4.3-.8.8-.8s.8.3.8.8v9c-.2 1.2-1.2 2.2-2.5 2.2H3.4Zm14.2-7.5v6h-4.4v-6c0-1.2 1-2.2 2.2-2.2 1.2 0 2.2 1 2.2 2.2Zm-9 4.5h-3c-.8 0-1.5-.7-1.5-1.5v-3c0-.8.7-1.5 1.5-1.5h3c.8 0 1.5.7 1.5 1.5v3c0 .8-.7 1.5-1.5 1.5Zm-3-4.5v3h3v-3h-3Zm9 1.9c0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.1-1.1-1.1-.6 0-1.1.5-1.1 1.1Z"
            clipRule="evenodd"
        ></path>
    </svg>
);

export const StoreIcon = styled(BaseStoreIcon)``;
